export default "__VITE_ASSET__6f89a088__"